import React from 'react'
import {
  Text,
  Title,
  Layout,
  Wrapper,
  Contents,
  Pricing,
  Name,
  Price,
  Button,
  Submit,
  Paymenttext,
  Change,
  Description,
} from './Transaction.styles'

function Transaction() {
  return (
    <Layout>
      <Wrapper>
        <img src='../images/converted-illustration-hero.jpg' alt=""/>
      </Wrapper>
      <Description>
        <Title>Order Summary</Title>
        <Text>you can now listen to millions of songs,audiobooks, and podcasts on any device anywhere you like!</Text>
        <Contents>
          <img src="../images/converted-icon-music.jpg" alt="" />
          <Pricing>
            <Name>Annual Plan</Name>
            <Price>$59.99/year</Price>
          </Pricing>
          <Change>change</Change>
        </Contents>

        {/* <Submit>
        </Submit> */}
        <Button>Proceed to Payment</Button>

        <Paymenttext>Cancel Order</Paymenttext>
      </Description>
    </Layout>
  )
}

export default Transaction
